import Helmet from "react-helmet";
import Pagination from "../search/pagination/";
import PressItem from "./press-item";
import React, { Component } from "react";
import request from "superagent";
import ResultsHeader from "./results-header";
import { getAgentIds, modifyFilter, parsePage } from "../shared/util";

import "./press.scss";

class Press extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        agentIds: getAgentIds(props.entity),
        activePage: parsePage(props),
        resultsPerPage: 10,
        byDate: "", //Last 6 months, Last year, 2022, 2021 ....
      },
      results: [],
      count: 0,
    };
  }

  componentDidMount() {
    this.fetchPress();
  }

  componentWillUnmount() {
    if (this.request) {
      this.request.abort();
    }
  }

  fetchPress = () => {
    this.request = request
      .post("/api/press")
      .set("Content-Type", "application/json")
      .send(this.state.filter)
      .end((err, response) => {
        if (err) {
          console.error(err);
        } else {
          const press = response.body ? response.body : {};
          if (press)
            this.setState({
              results: press.results,
              count: press.count,
            });
        }
      });
  };

  changeFilter = (name, value) => {
    const filter = modifyFilter(this.state.filter, name, value);
    this.setState({ filter: filter }, () => {
      this.fetchPress();
    });
  };

  render() {
    const title = `${this.props.entity.displayName} in the news | ${this.props.entity.brand}, Inc.`;
    return (
      <div className="press-page web-container container">
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta
            name="description"
            content={`Get the latest news and updates from ${this.props.entity.brand}, Inc. Specializing in luxury real estate properties in the country's finest locations.`}
          />
        </Helmet>
        <div className="row">
          <div className="page-header">
            <h3>In the News</h3>
            <div className="header-separator"></div>
          </div>
          <ResultsHeader
            changeFilter={this.changeFilter}
            resultState={this.state}
          />
          <div className="spacer-2"></div>
        </div>
        <ul className="item-list row" id="results-title">
          {this.state.results.map((p, i) => (
            <PressItem item={p} key={i} />
          ))}
        </ul>
        <Pagination
          count={this.state.count}
          activePage={this.state.filter.activePage}
          pageSize={this.state.filter.resultsPerPage}
          location={this.props.location}
          changeFilter={this.changeFilter}
        />
      </div>
    );
  }
}

export default Press;



// WEBPACK FOOTER //
// ./src/components/press/press.js